import FooterMenu from "./footer-menu";

export default function Footer() {
  return (
    <div className="border-t flex fixed bottom-0 w-screen bg-white z-40">
      <div className="flex h-16 items-center space-around px-2 space-y-8 w-full">
        <p className="text-slate-400 text-sm">
          &copy; {new Date().getFullYear()} Retire Planning Max. All Rights
          Reserved.
        </p>

        <div className="ml-auto flex items-center px-6">
          {/* <FooterMenu /> */}
        </div>
      </div>
    </div>
  );
}
